import { useEffect, useState } from "react";

import { Typography, Button, InfoPanel, DocumentList } from "@king-ict/eupisi-ui/components";
import { DocumentData } from "@king-ict/eupisi-ui/models";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import { getNotificationsForUser, downloadDocument } from "../../api/nisooApi";
import { DocumentType } from "../../models/Document";
import { Notification } from "../../models/Notification";
import { RoleEnum } from "../../models/User/RoleEnum";
import { useGetUserSessionQuery } from "../../queries/userQuery";
import { notificationAdministrationRoute } from "../../routes/routes";
import styles from "./NotificationList.module.scss";

export function NotificationList(){

    const history = useHistory();
    const { t } = useTranslation();

    const [notifications, setNotifications] = useState<Notification[]>([]); 
    const { data: userSession } = useGetUserSessionQuery();   

    useEffect(() => search(), []);

    const search = () => {
        (async() => {
            var result = await getNotificationsForUser();
            setNotifications(result);
        })();
    };

    const onEditNotificationsClick = () => {
        history.push(notificationAdministrationRoute());
    };

    const handleAttachmentDownload = async (document: DocumentData) => {
        if(document && document.id)
        {
            await downloadDocument(DocumentType.NotificationAttachment, document.id);
        }
    };
 

    return(
        <>
            {/* <Row className={styles.title}> */}            
            <Row>
                <Col md={10}>
                    <h2>{t("navigation.notifications")}</h2>
                </Col>
                {userSession && (userSession.roleId === RoleEnum.ASOOAdmin || userSession.roleId === RoleEnum.ASOOManager || userSession.roleId === RoleEnum.ASOOOffice 
                    || userSession.roleId === RoleEnum.CASAdmin || userSession.roleId === RoleEnum.CASManager || userSession.roleId === RoleEnum.CASOffice 
                    || userSession.roleId === RoleEnum.Helpdesk) &&
                    <Col md={2}>
                        <Button
                            outline                        
                            onClick={onEditNotificationsClick}
                            className={styles.actionButton}
                        >
                            {t("common.edit")}
                        </Button>
                    </Col>
                }
            </Row>
            {(notifications && notifications.length > 0) 
                ? (
                    <div className="mt-4 pr-5 mr-5">
                        {notifications.map((notification) => (
                            <Row className="mt-1 pt-0">
                                <Col md={12}>
                                    <InfoPanel
                                        color={notification.putOnTop ? `info` : `light`}
                                        message=""
                                        fullWidth={true}
                                        showIcon={false}
                                    >
                                         <p className={styles.notificationHeading}>{notification.title}</p>
                                         <hr className={styles.divider} />
                                         <p className={styles.notificationDate}>
                                            {new Date(notification?.validFrom!).toLocaleString("hr-HR", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit"                        
                                            })}
                                         </p>
                                         <br />
                                         <div className={styles.notificationMessage} dangerouslySetInnerHTML={{ __html: notification.message }}/>
                                         <br />
                                         <br />
                                         <DocumentList
                                            removable={false}
                                            documents={notification.attachments ?? []}
                                            onDocumentClick={handleAttachmentDownload}
                                         />
                                    </InfoPanel>
                                </Col>

                            </Row>
                        ))}
                    </div>                    
                ) 
                : (
                    <Row className="mt-4">
                        <Col md={12} className={styles.emptyList}>
                            <Typography variant={"largeBold"} component="h2">
                                {t("common.noData")}
                            </Typography>                            
                        </Col>
                    </Row>                                                
                )
            }
            
        </>
    );
};